import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';
import { ScrollView } from 'react-native-gesture-handler';




export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
 
`;

export const Content = styled.View`
  flex: 1;
`;

export const ContentHeader = styled.View`
  margin: 0 24px;
  margin-bottom: ${RFValue(6)}px;
`;

//@ts-ignore
export const Regions = styled(ScrollView)`
  flex: 1;
`;

export const RegionContainer = styled.TouchableHighlight.attrs(() => ({
  activeOpacity: 1,
}))`
  padding: 0 24px;
  flex-direction: row;
  height: ${RFValue(50)}px;
  justify-content: space-between;
  align-items: center;
  border-style: solid;
  border-color: ${({theme}) => theme.colors.border};
  border-bottom-width: 1px;
`;

export const RegionTitleContainer = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const RegionTitle = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.blue};
`;

export const ArrowIcon = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.text_dark};
`;

export const EmptyContainer = styled.View`
  flex: 1;
  align-items: center;
  justify-content: center;
`;

export const EmptyIcon = styled(Feather)`
  color: ${({theme}) => theme.colors.primary};
  margin-bottom: 12px;
  font-size: ${RFValue(24)}px;
  text-align: center;
`;

export const Empty = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(14)}px;
  text-align: center;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const NotFoundContainer = styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
`;
